import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  cursor: pointer;
`;

const Arrow = styled.div`
  transform-origin: 40px 40px;
  animation: lightSpin 1.2s linear infinite;
  position: absolute;
  width: 40px;
  height: 40px;
  top: calc(50% - 40px);
  left: calc(50% - 40px);
  &:after {
    content: ' ';
    display: block;
    position: absolute;
    top: 20px;
    left: 40px;
    width: 3px;
    height: 10px;
    border-radius: 20%;
    background-color: ${({ theme }) => theme.customColors.primary};
  }

  &:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  &:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }
  &:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }
  &:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }
  &:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }
  &:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }
  &:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }
  &:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }
  &:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }
  &:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }
  &:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }
  &:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
  @keyframes lightSpin {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

export const LightSpinner = () => (
  <Wrapper>
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
    <Arrow />
  </Wrapper>
);
